<template>
    <div class="color-select-holder">
        <div class="color-select" :class="{open: open}">
            <div class="color placeholder" v-if="placeholderVisible" @click="open = !open">{{placeholder}}...</div>
            <div class="color" v-for="color of colors" :class="{selected: value === color.value}" @click="changeColor(color.value)">
                {{color.name}}
                <div class="preview-hexa">{{color.value}}</div>
                <div class="preview" :style="{backgroundColor: color.value}"></div>
            </div>
            <div class="color" :class="{selected: customColor}" @click="showCustomColor">Couleur personnalisée</div>
        </div>
        <div class="custom-color" v-if="customColor">
            <input type="color" v-model="custom" @change="$emit('changed',custom)">
        </div>
    </div>
</template>

<script>
    export default {

      name: "colorSelector",

      props: {
        colors: Array,
        value: String,
        placeholder: String
      },

      mounted() {
        if (this.customColor) {
          this.custom = this.value;
        }
      },

      data() {
        return {
          open: false,
          customColorSelected: false,
          custom: "",
        }
      },

      computed: {
        placeholderVisible() {
          return this.value.length === 0 && !this.customColorSelected;
        },
        customColor() {
          return this.customColorSelected || (!(this.value.length === 0) && this.colors.filter(x => x.value === this.value).length === 0);
        }
      },

      methods: {
        changeColor(color) {
          this.open = !this.open;
          this.customColorSelected = false;
          this.$emit("changed", color);
        },
        showCustomColor() {
          this.open = !this.open;
          this.customColorSelected = true;
          this.$emit("changed", this.custom);
        }
      }

    }
</script>

<style lang="scss" scoped>
    .color-select-holder {
        display: flex;
    }
    .color-select {
        background-color: white;
        flex-grow: 1;
        border-radius: 4px;
        border: solid 1px #d9d9d9;
        font-size: 18px;
        font-family: 'Roboto';
        color: #404040;
        margin-bottom: 6px;
        position: relative;
        max-height: 44px;
        cursor: pointer;

        .color {
            padding: 9px 14px;
            display: flex;
            align-items: center;

            .preview {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                outline: 1px solid #d9d9d9;
                border: 1.5px solid white;
            }
            .preview-hexa {
                flex-grow: 1;
                display: flex;
                justify-content: flex-end;
                margin-right: 10px;
                font-size: 15px;
                letter-spacing: 0.5px;
                font-family: monospace;
                color: #aaa;
            }
        }

        .color:not(.selected) {
            display: none;
        }

        .color.placeholder {
            display: flex;
        }

        &.open {
            border: none;
            z-index: 99;

            .color {
                display: flex;
                background-color: white;
                border-left: 1px solid #d9d9d9;
                border-right: 1px solid #d9d9d9;

                &.placeholder {
                    font-style: italic;
                }

                &.selected:not(.placeholder) {
                    background-color: #f1f1f1;
                    font-weight: bold;
                }

                &:first-of-type {
                    border-top: 1px solid #d9d9d9;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                }

                &:last-of-type {
                    border-bottom: 1px solid #d9d9d9;
                    border-bottom-left-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
        }

        &::after {
            content: "▼";
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 0.7em;
        }
    }

    .custom-color {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        width: 100px;

        input[type=color] {
            flex-grow: 1;
            margin-bottom: 6px;
        }
    }

</style>